// Ana Sayfa (Home) — tüm bölüm metinleri (TR / EN). Faz 2.
// Not: Proje/blog kartlarının başlık-özet gibi içerikleri veritabanından gelir ve
// admin panelinde girildiği dilde görünür; burada yalnızca arayüz metinleri çevrilir.

export const HOME_I18N = {
  tr: {
    seo: {
      title: "Kurumsal Yazılım ve Yapay Zekâ Çözümleri | Dijital Roket",
      description:
        "Dijital Roket; şirketlere özel B2B, ERP/CRM, operasyon yönetimi, AI Agent, otomasyon, dashboard ve API entegrasyonları geliştirir. Hızlı geliştirme ve sürekli destek.",
    },
    hero: {
      badge: "Kurumsal Yazılım · Üretken Yapay Zekâ · Otomasyon",
      title1: "Şirketinizin İhtiyaçlarını",
      titleAccent: "IŞIK HIZINDA",
      title2: "hayata geçiriyoruz.",
      desc: "B2B bayi sistemlerinden şirket içi operasyon platformlarına, yapay zekâ ajanlarından yönetici panellerine kadar kurumunuza özel yazılımlar geliştiriyoruz. DR AI destekli geliştirme modelimizle çalışan ilk versiyonu çok kısa sürede ortaya çıkarıyor, sisteminizi sürekli geliştiriyor ve kritik süreçlerde 7/24 destekliyoruz.",
      ctaPrimary: "İhtiyacınızı Analiz Edelim",
      ctaSecondary: "Kurumsal Çözümleri İnceleyin",
      liveSystems: "Canlı Sistemler",
      exploreSystem: "Sistemi inceleyin",
      noImage: "Görsel yok",
      dotAria: (i) => `Sistem ${i}`,
      panelAlt: "Kurumsal yazılım paneli",
      trust: [
        { t: "Hızlı Prototipleme", d: "24/48 saatte çalışan ilk versiyon." },
        { t: "7/24 Kritik Destek", d: "Yeni özellik veya acil durumlarda anında hizmet sağlıyoruz." },
        { t: "Kuruma Özel Mimari", d: "Hazır paket değil! Siz bizim yazılımımıza değil biz sizin şirketinize göre geliştiriyoruz." },
        { t: "Generative AI/Üretken AI", d: "Tüm yazılımlarımız en güncel yapay zeka teknolojileri ile donatılmıştır." },
      ],
    },
    marquee: {
      title: "Gerçek Operasyonlarda Çalışan Sistemler",
      hint: "Durdurmak için üzerine gelin",
    },
    solutions: {
      eyebrow: "Ne Geliştiriyoruz?",
      title1: "Kurumunuza Özel",
      titleAccent: "Kurumsal Yazılım Çözümleri",
      desc: "Web sitesi ya da tek bir modül değil; şirketinizin günlük operasyonunu yürüten sistemler geliştiriyoruz. İhtiyacınızı analiz ediyor, size özel mimariyi kuruyor ve büyümeye açık bir altyapı teslim ediyoruz.",
      link: "Tüm Kurumsal Çözümleri Gör",
      items: [
        { t: "Kurumsal Operasyon Sistemleri", d: "Şirket içinde Excel, WhatsApp, e-posta ve farklı yazılımlara dağılmış süreçleri tek platformda birleştiriyoruz." },
        { t: "B2B Bayi & Sipariş Sistemleri", d: "Bayi fiyatlandırması, stok, sipariş, cari, iskonto, teklif ve ürün yönetimini şirketinize özel dijital altyapıya taşıyoruz." },
        { t: "ERP / CRM Benzeri Özel Yazılımlar", d: "Hazır yazılımların şirketinize uymadığı noktalarda operasyonunuza göre sıfırdan sistem geliştiriyoruz." },
        { t: "Yapay Zekâ Agent & Otomasyonları", d: "E-posta, teklif, müşteri hizmetleri, operasyon, doküman ve karar süreçlerini AI Agent'larla otomatikleştiriyoruz." },
        { t: "Yönetici Dashboard & Veri Sistemleri", d: "Şirket verilerini karar alınabilir hale getiren gerçek zamanlı yönetim ekranları ve raporlama altyapıları geliştiriyoruz." },
        { t: "API & Sistem Entegrasyonları", d: "ERP, CRM, muhasebe, ödeme, rezervasyon, e-posta ve üçüncü parti servisleri tek sistem altında konuşturuyoruz." },
      ],
    },
    cases: {
      eyebrow: "Başarı Hikâyeleri",
      title: "Gerçek Operasyonlarda Çalışan Sistemler",
      desc: "Sadece demo veya konsept üretmiyoruz. Geliştirdiğimiz sistemler şirketlerin günlük operasyonlarının aktif bir parçası olarak çalışıyor.",
      viewAll: "Tüm Hikâyeler",
      explore: "Sistemi inceleyin",
    },
    spotlight: {
      badge: "Dijital Roket Ürünü",
      subBadge: "Travel Automation System",
      lead1: "Talep gelsin. Teklif anında gitsin.",
      lead2: "Müşteriniz seçsin. TAS Flow rezerve etsin.",
      desc: "Seyahat acentelerinin operasyonlarını yapay zekâ ve otomasyonla uçtan uca yöneten yeni nesil altyapı.",
      ctaExplore: "TAS Flow'u Keşfet",
      ctaDemo: "Canlı Demo İste",
      flow: ["Talep", "AI", "Sorgu", "Teklif", "Onay", "Rezervasyon"],
    },
    sprint: {
      eyebrow: "Hızlandırılmış Geliştirme",
      title1: "Aylar Süren Yazılım Süreçlerini",
      titleAccent: "Hızlandırılmış Sprintlere Dönüştürüyoruz.",
      desc: "DR AI destekli geliştirme altyapımız analiz, mimari planlama, arayüz üretimi, prototipleme, kod geliştirme ve test süreçlerini hızlandırır. Böylece büyük fikirleri uzun sunum ve tasarım süreçlerinde bekletmek yerine, çok kısa sürede çalışan bir ilk versiyona dönüştürebiliriz.",
      note: "Hızlı geliştiriyoruz; ancak \u201Cacele yazılım\u201D üretmiyoruz. Yeni nesil geliştirme yöntemleri sayesinde geleneksel yazılım süreçlerinden çok daha hızlı sonuç üretiyoruz.",
      steps: [
        { t: "İhtiyacınızı Dinliyoruz", d: "Süreçleri, kullanıcıları ve hedefleri analiz ediyoruz." },
        { t: "Sistem Mimarisini Çıkarıyoruz", d: "Modüller, roller, veri akışları ve entegrasyonlar belirleniyor." },
        { t: "Çalışan Prototipi Gösteriyoruz", d: "Uygun projelerde aynı gün veya çok kısa sürede çalışan ilk deneyimi ortaya çıkarıyoruz." },
        { t: "Üretim Sprintine Geçiyoruz", d: "Öncelikli modülleri hızla canlı sisteme dönüştürüyoruz." },
        { t: "Test & Canlı Kullanım", d: "Yetkiler, akışlar, mobil kullanım ve temel güvenlik kontrolleri tamamlanıyor." },
        { t: "Sistem Büyümeye Devam Ediyor", d: "Yeni modüller, entegrasyonlar ve iş ihtiyaçları sürekli geliştiriliyor." },
      ],
    },
    scale: {
      eyebrow: "Ölçeklenebilir Sistemler",
      title1: "Küçük Bir Panelden",
      titleAccent: "Şirketinizin Dijital Omurgasına Kadar.",
      desc: "Projenin sınırını hazır paketler değil, iş ihtiyacınız belirler. Tek bir yönetim ekranından çok kullanıcılı ve çok şirketli platformlara; yüksek trafikli sistemlerden yapay zekâ destekli operasyonlara kadar ölçeklenebilir mimariler geliştiriyoruz.",
      items: [
        "Multi-tenant mimari", "Çoklu kullanıcı & rol yönetimi", "Yetki matrisi", "Audit log",
        "REST / API entegrasyonları", "ERP / CRM entegrasyonu", "AI Agent entegrasyonları", "Gerçek zamanlı dashboard",
        "Büyük veri işleme", "Mobil / PWA arayüz", "Cloud mimari", "Otomatik raporlama",
        "Bildirim sistemleri", "E-posta otomasyonu", "Doküman / PDF üretimi", "Workflow automation",
      ],
    },
    support: {
      eyebrow: "7/24 Destek & Sürekli Geliştirme",
      title1: "Yazılımı Teslim Edip Gitmiyoruz.",
      titleAccent: "Sisteminiz Yaşadıkça Biz de Yanınızdayız.",
      desc: "Kurumsal yazılım ihtiyaçları proje yayına alındığında bitmez. Şirket büyür, süreçler değişir, yeni ihtiyaçlar ortaya çıkar. Dijital Roket bu nedenle yalnızca yazılım geliştiren bir tedarikçi değil, sürekli teknoloji partneri olarak çalışır.",
      cta: "Kurumsal Görüşme Planlayın",
      cards: [
        { t: "7/24 Kritik Destek", d: "Operasyonu etkileyen kritik durumlarda ekibimize ulaşabilirsiniz." },
        { t: "Hızlı Müdahale", d: "Yeni ihtiyaçlar ve operasyonel talepler uzun geliştirme kuyruklarında beklemek zorunda değildir." },
        { t: "Sürekli Geliştirme", d: "Yeni modüller, raporlar, entegrasyonlar ve otomasyonlar sisteme eklenebilir." },
        { t: "Kurumsal SLA", d: "Kurumsal projelerde ihtiyaca göre önceliklendirme ve destek seviyesi planlanabilir." },
      ],
    },
    drAi: {
      eyebrow: "AI-Native Software Development",
      title1: "Yazılım Geliştirme Sürecini",
      titleAccent: "Yapay Zekâ ile Yeniden Tasarladık.",
      desc1: "DR AI; Dijital Roket'in analiz, prototipleme, arayüz geliştirme, kod üretimi, içerik, test ve dokümantasyon süreçlerinde kullandığı yapay zekâ destekli geliştirme altyapısıdır. İnsan mühendisliği ve proje yönetimini ortadan kaldırmak yerine ekibimizin üretim kapasitesini artırır.",
      desc2: "Bu sayede müşterilerimize daha kısa geliştirme döngüleri ve çok daha hızlı revizyon imkânı sağlayabiliriz.",
      areas: [
        { t: "Analiz", d: "İhtiyaç ve süreç analizini hızlandırır." },
        { t: "Arayüz & Prototip", d: "Çalışan arayüz ve prototipleri kısa sürede üretir." },
        { t: "Kod Üretimi", d: "Geliştirme döngülerini ekibimizle birlikte hızlandırır." },
        { t: "İçerik", d: "Metin ve içerik üretim süreçlerini destekler." },
        { t: "Test", d: "Test senaryolarının hazırlanmasına yardımcı olur." },
        { t: "Dokümantasyon", d: "Teknik doküman ve kayıt üretimini kolaylaştırır." },
      ],
    },
    partner: {
      eyebrow: "Roket Partner",
      title1: "Şirketinizin Harici",
      titleAccent: "Yazılım Departmanı Gibi Çalışıyoruz.",
      desc: "Roket Partner modeliyle yazılımınız bir proje olarak başlayıp donmuş bir sisteme dönüşmez. Şirketinizin teknoloji backlog'unu birlikte yönetir; yeni modülleri, entegrasyonları, otomasyonları ve iyileştirmeleri sürekli geliştiririz.",
      cta: "Teknoloji Partnerliği Hakkında Görüşelim",
      note: "Metrikler proje bazlı teknik ölçek ve mimari yaklaşımı yansıtır.",
      items: [
        "Yeni özellik geliştirme", "API ve sistem entegrasyonları", "AI otomasyonları", "Yönetici raporları",
        "Performans optimizasyonu", "Bug fix ve bakım", "Yeni kullanıcı akışları", "Öncelikli sprint planlaması",
      ],
      proof: [
        { v: "50M+", l: "Aylık istek ölçeğine göre tasarım" },
        { v: "1.850+", l: "Veri / model içeren B2B katalog" },
        { v: "Multi-tenant", l: "Kurumsal sistem mimarisi" },
        { v: "7/24", l: "Kritik destek" },
      ],
    },
    trust: {
      eyebrow: "Kurumsal Disiplin",
      title1: "Hızlı Geliştirme.",
      titleAccent: "Kurumsal Disiplin.",
      desc: "Hız bizim için analiz, güvenlik veya mimariden vazgeçmek anlamına gelmez. Projenin kullanıcı rolleri, veri yapısı, yetkilendirmesi, entegrasyonları ve büyüme senaryoları geliştirme sürecinin başında ele alınır.",
      items: [
        "Sistem Mimarisi", "Rol & Yetkilendirme", "Audit & İzlenebilirlik", "Mobil Uyumluluk",
        "API Entegrasyonları", "Test & QA", "Yedekleme Yaklaşımı", "Sürekli Geliştirme",
      ],
    },
    blog: {
      eyebrow: "İçgörüler",
      title: "Dijital Dönüşüm Bloğu",
      desc: "Kurumsal web, B2B sistemler, CRM, AI üretimi ve dijital dönüşüm üzerine güncel içgörüler.",
      viewAll: "Tüm Yazılar",
      readTime: (n) => `${n} dk okuma`,
      readMore: "Devamını oku",
    },
    faq: {
      eyebrow: "Sık Sorulan Sorular",
      title: "Kurumsal projeler hakkında merak edilenler",
      desc: "Özel yazılım, entegrasyon, veri güvenliği, ölçeklenme ve destek süreçleri hakkında kurumsal müşterilerimizin en çok sorduğu sorular.",
      items: null, // TR içerik admin panelinden (settings.home_faq) gelir
    },
    finalCta: {
      title1: "Şirketinizde Hâlâ Excel, WhatsApp ve",
      titleAccent: "Manuel İşleyen Süreçler mi Var?",
      desc: "Bize mevcut sürecinizi anlatın. Hangi bölümlerin yazılım, otomasyon veya yapay zekâ ile dönüştürülebileceğini birlikte çıkaralım. İlk görüşmede size ürün satmaya değil, problemi anlamaya odaklanıyoruz.",
      ctaPrimary: "Sürecimi Analiz Edin",
      ctaSecondary: "Kurumsal Görüşme Planlayın",
    },
  },

  en: {
    seo: {
      title: "Enterprise Software & Artificial Intelligence Solutions | Dijital Roket",
      description:
        "Dijital Roket builds custom B2B platforms, ERP/CRM systems, operations management software, AI agents, automation, dashboards and API integrations for companies — with rapid delivery and continuous support.",
    },
    hero: {
      badge: "Enterprise Software · Generative AI · Automation",
      title1: "We bring your company's needs to life",
      titleAccent: "AT THE SPEED OF LIGHT",
      title2: "",
      desc: "From B2B dealer portals to internal operations platforms, from AI agents to executive dashboards, we build software tailored to your organisation. With our DR AI-powered development model we deliver a working first version in a very short time, keep improving your system and support your critical processes 24/7.",
      ctaPrimary: "Let's Analyse Your Needs",
      ctaSecondary: "Explore Enterprise Solutions",
      liveSystems: "Live Systems",
      exploreSystem: "Explore the system",
      noImage: "No image",
      dotAria: (i) => `System ${i}`,
      panelAlt: "Enterprise software dashboard",
      trust: [
        { t: "Rapid Prototyping", d: "A working first version in 24–48 hours." },
        { t: "24/7 Critical Support", d: "We respond immediately for new features or urgent situations." },
        { t: "Architecture Built for You", d: "Not an off-the-shelf package. You don't adapt to our software — we build around your company." },
        { t: "Generative AI", d: "All of our software is equipped with the latest artificial intelligence technologies." },
      ],
    },
    marquee: {
      title: "Systems Running in Real Operations",
      hint: "Hover to pause",
    },
    solutions: {
      eyebrow: "What Do We Build?",
      title1: "Enterprise Software Solutions",
      titleAccent: "Tailored to Your Organisation",
      desc: "Not a website or a single module — we build the systems that run your company's daily operation. We analyse your needs, design an architecture for you and deliver an infrastructure ready to grow.",
      link: "See All Enterprise Solutions",
      items: [
        { t: "Enterprise Operations Systems", d: "We unify processes scattered across Excel, WhatsApp, email and separate tools into a single platform." },
        { t: "B2B Dealer & Order Systems", d: "We move dealer pricing, stock, orders, balances, discounts, quotes and product management onto a digital infrastructure built for you." },
        { t: "Custom ERP / CRM-Class Software", d: "Where off-the-shelf software doesn't fit, we build systems from scratch around your operation." },
        { t: "AI Agents & Automation", d: "We automate email, quoting, customer service, operations, documents and decision processes with AI agents." },
        { t: "Executive Dashboards & Data Systems", d: "We build real-time management screens and reporting infrastructure that turn company data into decisions." },
        { t: "API & System Integrations", d: "We make ERP, CRM, accounting, payment, booking, email and third-party services talk to each other in one system." },
      ],
    },
    cases: {
      eyebrow: "Success Stories",
      title: "Systems Running in Real Operations",
      desc: "We don't just build demos or concepts. The systems we develop run as an active part of our clients' daily operations.",
      viewAll: "All Stories",
      explore: "Explore the system",
    },
    spotlight: {
      badge: "A Dijital Roket Product",
      subBadge: "Travel Automation System",
      lead1: "Let the request come in. Let the quote go out instantly.",
      lead2: "Let your customer choose. Let TAS Flow book it.",
      desc: "A new-generation infrastructure that runs travel agency operations end to end with artificial intelligence and automation.",
      ctaExplore: "Explore TAS Flow",
      ctaDemo: "Request a Live Demo",
      flow: ["Request", "AI", "Search", "Quote", "Approval", "Booking"],
    },
    sprint: {
      eyebrow: "Accelerated Development",
      title1: "We Turn Software Projects That Take Months",
      titleAccent: "Into Accelerated Sprints.",
      desc: "Our DR AI-powered development infrastructure accelerates analysis, architecture planning, interface production, prototyping, coding and testing. So instead of parking big ideas in long presentation and design cycles, we turn them into a working first version very quickly.",
      note: "We move fast — but we don't build \u201Crushed software\u201D. New-generation development methods simply let us produce results far faster than traditional software processes.",
      steps: [
        { t: "We Listen to Your Needs", d: "We analyse your processes, users and goals." },
        { t: "We Design the System Architecture", d: "Modules, roles, data flows and integrations are defined." },
        { t: "We Show a Working Prototype", d: "For suitable projects we produce a working first experience the same day or within a very short time." },
        { t: "We Move Into the Production Sprint", d: "Priority modules are rapidly turned into a live system." },
        { t: "Testing & Go-Live", d: "Permissions, flows, mobile usage and core security checks are completed." },
        { t: "The System Keeps Growing", d: "New modules, integrations and business needs are developed continuously." },
      ],
    },
    scale: {
      eyebrow: "Scalable Systems",
      title1: "From a Small Panel",
      titleAccent: "to Your Company's Digital Backbone.",
      desc: "The limits of your project are set by your business needs, not by an off-the-shelf package. From a single admin screen to multi-user, multi-company platforms; from high-traffic systems to AI-powered operations, we build scalable architectures.",
      items: [
        "Multi-tenant architecture", "Multi-user & role management", "Permission matrix", "Audit log",
        "REST / API integrations", "ERP / CRM integration", "AI agent integrations", "Real-time dashboards",
        "Big data processing", "Mobile / PWA interface", "Cloud architecture", "Automated reporting",
        "Notification systems", "Email automation", "Document / PDF generation", "Workflow automation",
      ],
    },
    support: {
      eyebrow: "24/7 Support & Continuous Development",
      title1: "We Don't Deliver the Software and Disappear.",
      titleAccent: "We Stay With You for as Long as Your System Lives.",
      desc: "Enterprise software needs don't end when a project goes live. Companies grow, processes change, new needs appear. That's why Dijital Roket works as a long-term technology partner, not just a software vendor.",
      cta: "Schedule an Enterprise Call",
      cards: [
        { t: "24/7 Critical Support", d: "You can reach our team whenever something critical affects your operation." },
        { t: "Fast Response", d: "New needs and operational requests don't have to wait in long development queues." },
        { t: "Continuous Development", d: "New modules, reports, integrations and automations can be added to the system." },
        { t: "Enterprise SLA", d: "For enterprise projects, prioritisation and support levels can be planned around your needs." },
      ],
    },
    drAi: {
      eyebrow: "AI-Native Software Development",
      title1: "We Redesigned the Software Development Process",
      titleAccent: "Around Artificial Intelligence.",
      desc1: "DR AI is Dijital Roket's AI-powered development infrastructure, used across analysis, prototyping, interface development, code generation, content, testing and documentation. Instead of replacing human engineering and project management, it multiplies our team's output.",
      desc2: "That is how we can offer our clients shorter development cycles and far faster revisions.",
      areas: [
        { t: "Analysis", d: "Accelerates needs and process analysis." },
        { t: "Interface & Prototype", d: "Produces working interfaces and prototypes quickly." },
        { t: "Code Generation", d: "Speeds up development cycles together with our team." },
        { t: "Content", d: "Supports copy and content production." },
        { t: "Testing", d: "Helps prepare test scenarios." },
        { t: "Documentation", d: "Makes technical documentation and records easier to produce." },
      ],
    },
    partner: {
      eyebrow: "Roket Partner",
      title1: "We Work Like Your",
      titleAccent: "External Software Department.",
      desc: "With the Roket Partner model your software doesn't start as a project and end up as a frozen system. We manage your company's technology backlog together and continuously develop new modules, integrations, automations and improvements.",
      cta: "Let's Talk About Technology Partnership",
      note: "Metrics reflect project-level technical scale and architectural approach.",
      items: [
        "New feature development", "API and system integrations", "AI automations", "Executive reports",
        "Performance optimisation", "Bug fixes and maintenance", "New user flows", "Priority sprint planning",
      ],
      proof: [
        { v: "50M+", l: "Designed for monthly request scale" },
        { v: "1,850+", l: "B2B catalogue with data / models" },
        { v: "Multi-tenant", l: "Enterprise system architecture" },
        { v: "24/7", l: "Critical support" },
      ],
    },
    trust: {
      eyebrow: "Enterprise Discipline",
      title1: "Fast Development.",
      titleAccent: "Enterprise Discipline.",
      desc: "Speed never means giving up analysis, security or architecture. User roles, data structure, permissions, integrations and growth scenarios are addressed at the very beginning of development.",
      items: [
        "System Architecture", "Roles & Permissions", "Audit & Traceability", "Mobile Compatibility",
        "API Integrations", "Testing & QA", "Backup Approach", "Continuous Development",
      ],
    },
    blog: {
      eyebrow: "Insights",
      title: "Digital Transformation Blog",
      desc: "Current insights on enterprise web, B2B systems, CRM, AI-native production and digital transformation.",
      viewAll: "All Articles",
      readTime: (n) => `${n} min read`,
      readMore: "Read more",
    },
    faq: {
      eyebrow: "Frequently Asked Questions",
      title: "What companies ask about enterprise projects",
      desc: "The questions our enterprise clients ask most about custom software, integrations, data security, scaling and support.",
      items: [
        { q: "Can you integrate with our existing ERP or CRM system?", a: "Yes. We build integrations with ERP, CRM, accounting, payment, email and third-party services over REST/APIs. By automating the data flow between your systems we create a structure that runs from a single centre." },
        { q: "Can you build software that is fully custom to our company?", a: "Yes. Where off-the-shelf packages don't fit the way you work, we analyse your processes and build custom enterprise software from scratch — B2B dealer systems, operations platforms, ERP/CRM-class systems and executive dashboards are typical examples." },
        { q: "How soon can we see the first working prototype?", a: "Thanks to our DR AI-powered development model, for suitable projects we can produce a working first version in a very short time. The duration depends on scope, but instead of parking the idea in long design cycles we make it experienceable fast." },
        { q: "Do you provide support after the software goes live?", a: "Yes. We don't hand over the project and walk away. With our Roket Partner model we keep developing new modules, integrations, reports and improvements after go-live." },
        { q: "Do you offer 24/7 support?", a: "For enterprise projects we provide 24/7 reachable support for critical situations that affect the operation. Prioritisation and support levels (SLA) can be planned as needed." },
        { q: "Can new features be added to the system later?", a: "Yes. The systems we build are set up with an architecture ready to grow. New user flows, modules, reports, automations and integrations can be added over time." },
        { q: "Can several companies, branches or dealers work in the same system?", a: "Yes. With multi-tenant architecture plus multi-user and role management, multiple companies, branches or dealers can work on the same platform with their own permissions and data." },
        { q: "How is artificial intelligence integrated into our existing processes?", a: "We support your email, quoting, customer service, document and decision processes with AI agents and automation. Rather than replacing your team, AI is integrated into your process to speed up repetitive work and simplify operations." },
        { q: "When should custom software be preferred over off-the-shelf products?", a: "Custom software is more efficient and scalable when packaged software doesn't fully match your processes, when there is a lot of manual work or flows running over Excel/WhatsApp, or when you have a way of working that gives you a competitive edge." },
        { q: "How are data security and user permissions managed?", a: "Role-based authorisation (a permission matrix), user-level access control and traceability approaches such as audit logs govern who accesses your data and from where. Security is addressed at the start of the development process." },
      ],
    },
    finalCta: {
      title1: "Still Running Your Company on Excel, WhatsApp and",
      titleAccent: "Manual Processes?",
      desc: "Tell us about your current process. Let's work out together which parts can be transformed with software, automation or artificial intelligence. In the first call we focus on understanding the problem, not selling you a product.",
      ctaPrimary: "Analyse My Process",
      ctaSecondary: "Schedule an Enterprise Call",
    },
  },
};
